var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box modal-card", staticStyle: { overflow: "visible" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.isLoading },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("p", { staticClass: "title is-4" }, [_vm._v(" Set Up Forecasts ")]),
      _c(
        "div",
        { staticClass: "has-text-centered" },
        [
          _c("h5", { staticClass: "title has-text-centered is-5" }, [
            _vm._v("Orders per Week"),
          ]),
          _c("h6", { staticClass: "is-italic" }, [
            _vm._v(
              " Input the expected number of orders per week for the launch of the new kitchen."
            ),
          ]),
          _c(
            "b-field",
            { attrs: { label: " ", expanded: "" } },
            [
              _c("b-numberinput", {
                attrs: { size: "is-small", type: "number" },
                model: {
                  value: _vm.selectedOrdersPerWeek,
                  callback: function ($$v) {
                    _vm.selectedOrdersPerWeek = $$v
                  },
                  expression: "selectedOrdersPerWeek",
                },
              }),
            ],
            1
          ),
          _c("h4", { staticClass: "title has-text-centered is-5" }, [
            _vm._v("Source Kitchen"),
          ]),
          _c("h6", { staticClass: "is-italic" }, [
            _vm._v(
              " The forecasts created are based on the distribution of Menu Items per day of the selected kitchen."
            ),
          ]),
          _c(
            "b-field",
            { attrs: { grouped: "" } },
            [
              _c(
                "b-field",
                { attrs: { label: "Country" } },
                [
                  _c(
                    "b-select",
                    {
                      attrs: {
                        type: "text",
                        placeholder: "Country",
                        expanded: "",
                      },
                      model: {
                        value: _vm.selectedCountry,
                        callback: function ($$v) {
                          _vm.selectedCountry = $$v
                        },
                        expression: "selectedCountry",
                      },
                    },
                    _vm._l(
                      _vm.getExistingKitchenCountries(
                        _vm.countries,
                        _vm.locations,
                        _vm.kitchens
                      ),
                      function (kitchenCountry, index) {
                        return _c(
                          "option",
                          {
                            key: index,
                            domProps: { value: kitchenCountry.uuid },
                          },
                          [_vm._v(" " + _vm._s(kitchenCountry.label) + " ")]
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "Licensee" } },
                [
                  _c(
                    "b-select",
                    {
                      attrs: {
                        type: "text",
                        placeholder: "Licensee",
                        expanded: "",
                      },
                      model: {
                        value: _vm.selectedPartner,
                        callback: function ($$v) {
                          _vm.selectedPartner = $$v
                        },
                        expression: "selectedPartner",
                      },
                    },
                    _vm._l(_vm.kitchenStatus, function (kitchenStat, index) {
                      return _c(
                        "option",
                        { key: index, domProps: { value: kitchenStat.value } },
                        [_vm._v(" " + _vm._s(kitchenStat.label) + " ")]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "Kitchen", expanded: "" } },
                [
                  _c(
                    "b-select",
                    {
                      attrs: {
                        type: "text",
                        placeholder: "Kitchen",
                        expanded: "",
                      },
                      model: {
                        value: _vm.selectedExisingKitchen,
                        callback: function ($$v) {
                          _vm.selectedExisingKitchen = $$v
                        },
                        expression: "selectedExisingKitchen",
                      },
                    },
                    _vm._l(
                      _vm.getExistingKitchens(
                        _vm.selectedCountry,
                        _vm.selectedPartner,
                        _vm.locations,
                        _vm.kitchens,
                        false,
                        _vm.kitchenUUID
                      ),
                      function (kitchen, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: kitchen } },
                          [_vm._v(" " + _vm._s(kitchen.id) + " ")]
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("h4", { staticClass: "title has-text-centered is-5" }, [
            _vm._v("Base Week"),
          ]),
          _c("h6", { staticClass: "is-italic" }, [
            _vm._v(
              " Select the week from which the sales will be copied. The selected week must have sales on every day of the week. If you don't select anything, last week is used."
            ),
          ]),
          _c(
            "b-field",
            { attrs: { label: " " } },
            [
              _c("b-datepicker", {
                attrs: {
                  placeholder: "Select Date",
                  icon: "calendar-today",
                  position: "is-top-right",
                  "unselectable-dates": _vm.unselectableSourceDates,
                  "unselectable-days-of-week": _vm.unselectableDaysOfWeek,
                  "trap-focus": "",
                },
                model: {
                  value: _vm.selectedSourceDate,
                  callback: function ($$v) {
                    _vm.selectedSourceDate = $$v
                  },
                  expression: "selectedSourceDate",
                },
              }),
            ],
            1
          ),
          _vm.selectedOrdersPerWeek &&
          _vm.selectedCountry &&
          _vm.selectedPartner != null &&
          _vm.selectedExisingKitchen
            ? _c(
                "b-button",
                {
                  staticClass: "button-gap",
                  attrs: { type: "is-info", expanded: "" },
                  on: {
                    click: function ($event) {
                      return _vm.create(
                        _vm.selectedExisingKitchen,
                        _vm.selectedOrdersPerWeek,
                        _vm.selectedSourceDate
                      )
                    },
                  },
                },
                [_vm._v(" Set Up ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }